import { FC } from 'react';

import { Link } from '@dbt-labs/sourdough';

import { InheritedDescriptionDisplay } from '@/components/Description';
import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';
import { PanelDetails } from './panelDetailTypes';

export const Description: FC<
  Pick<
    PanelDetails,
    'description' | 'descriptionOriginColumnName' | 'descriptionOriginResourceUniqueId'
  > & { className?: string; defaultDescription?: string }
> = ({
  description,
  defaultDescription,
  descriptionOriginColumnName,
  descriptionOriginResourceUniqueId,
  className,
}) => {
  const getOriginResourceLink = useLinkToExplorer('resourceDetails');
  const urlParams = useUrlProjectParams();

  /** For simplicity, we're reusing this flag for Cam. */
  const isDescriptionInherited =
    !!description &&
    !!descriptionOriginColumnName &&
    !!descriptionOriginResourceUniqueId;

  return (
    <InheritedDescriptionDisplay
      description={description}
      defaultDescription={defaultDescription}
      isDescriptionInherited={isDescriptionInherited}
      className={className}
      inheritedInfo={
        isDescriptionInherited && (
          <>
            <Link
              to={getOriginResourceLink({
                dbtUniqueId: descriptionOriginResourceUniqueId,
                ...urlParams,
                originColumn: descriptionOriginColumnName,
                tab: 'columns',
              })}
              isInternal
              children={descriptionOriginColumnName}
            />{' '}
            in{' '}
            <Link
              to={getOriginResourceLink({
                dbtUniqueId: descriptionOriginResourceUniqueId,
                ...urlParams,
              })}
              isInternal
              children={descriptionOriginResourceUniqueId.split('.').pop()}
            />
          </>
        )
      }
    />
  );
};

export const PanelDescription: FC<
  Pick<
    PanelDetails,
    | 'description'
    | 'fetching'
    | 'descriptionOriginColumnName'
    | 'descriptionOriginResourceUniqueId'
  >
> = (props) => {
  if (props.fetching) return null;
  return (
    <div className="mb-2" data-testid="description-block">
      <h2 className="mb-4 text-xs font-medium text-fgMain">Description</h2>
      <Description
        {...props}
        defaultDescription="No description provided."
        className="mb-2 text-sm"
      />
    </div>
  );
};
